import React from 'react';
import Button from '../../../components/ui/Button';


const CategoryFilter = ({ categories, activeCategory, onCategoryChange }) => {
  return (
    <div className="flex flex-wrap gap-3 justify-center mb-12">
      {categories?.map((category) => (
        <Button
          key={category?.id}
          variant={activeCategory === category?.id ? "default" : "outline"}
          size="default"
          onClick={() => onCategoryChange(category?.id)}
          iconName={category?.icon}
          iconPosition="left"
          className={`transition-all duration-500 ${
            activeCategory === category?.id 
              ? `bg-[${category?.accentColor}] text-white border-[${category?.accentColor}] hover:bg-[${category?.accentColor}]/90` 
              : `border-[${category?.accentColor}] text-[${category?.accentColor}] hover:bg-[${category?.accentColor}]/10`
          }`}
        >
          {category?.name}
        </Button>
      ))}
    </div>
  );
};

export default CategoryFilter;